import Container from 'typedi';
import IHTTPClientAdapter from '../adapters/HTTPClientAdapter/IHTTPClientAdapter';

class LogRepository {
  httpClientAdapter;
  lastmileApiUrl;
  constructor() {
    this.httpClientAdapter = Container.get(IHTTPClientAdapter);
    this.lastmileApiUrl = Container.get('ENV_API_URL');
  }
  sendInfo(message) {
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/tlflogapi/v1/log`;
    const body = this.getBody(message);
    body.type = "INFO";
    try {
      const header = {
        Authorization: 'Bearer ' + accessToken,
      };
      this.httpClientAdapter.post(url, body, header);
    } catch (e) {
      console.log("1) Este body se trato de enviar al log ",body);
      console.log("2) Fallo el envio de logs ",e);
    }
  }
  sendError(message){
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/tlflogapi/v1/log`;
    const body = this.getBody(message);
    body.type = "ERROR";
    try {
      const header = {
        Authorization: 'Bearer ' + accessToken,
      };
      this.httpClientAdapter.post(url, body, header);
    } catch (e) {
      console.log("1) Este body se trato de enviar al log ",body);
      console.log("2) Fallo el envio de logs ",e);
    }
  }

  getBody(message){
    const clientId = Container.get('clientId');
    const userId = Container.get('userId');
    const clientName = Container.get('clientName');
    const body = {
      ...message,
      userId: userId != null && userId != '' ? userId : "No hay usuario logueado", 
      idClient: clientId != null && clientId != '' ? clientId : "No hay cliente logueado",
      clientName: clientName ? clientName : "El nombre de cliente no se registro", 
      browser: this.getBrowserName(),
      createdAt: new Date(),
    };
    return body;
  }
  getBrowserName() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Firefox")) {
      return "Mozilla Firefox";
    } else if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
      return "Google Chrome";
    } else if (userAgent.includes("Edg")) {
      return "Microsoft Edge";
    } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      return "Safari";
    } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
      return "Opera";
    } else if (userAgent.includes("Trident") || userAgent.includes("MSIE")) {
      return "Internet Explorer";
    } else {
      return "Unknown Browser";
    }
  }
}

Container.set({ id: LogRepository, type: LogRepository });

export default LogRepository;
